module.exports = __webpack_public_path__ + "60e6bf27d45655a888a2d9febf5db2da.geojson";